<template>
  <div class="posts">
    <div class="container">
      <h1>
        <font-awesome-icon icon="newspaper" />
        Neuigkeiten und Aktuelles
      </h1>
      <p class="text">
        Aktuelle <b>Nachrichten</b>, <b>Informationen</b>, anstehende <b>Termine</b>  und <b>Bilder</b> 
        zur Feuerwehr aus Pfaffenhofen.
      </p>
      <div class="flex-row">
        <div class="card" v-for="item in posts.slice(0,1)" :key="item.id" >
          <div class="content">
            <div class="category" v-if="item.category">
              <font-awesome-icon icon="tags" />
              {{item.category}}
            </div>
            <div class="title">{{item.title}}</div>
            <router-link to="aktuelles">
              <div class="body" v-html="item.description"></div> 
            </router-link>
            <div class="footer">
              <div class="footer-item">
                <font-awesome-icon icon="clock" />
                {{item.time}}
              </div>
              <div class="footer-item">
                <font-awesome-icon icon="user" />
                {{item.creator}}
              </div>
              <div class="btn-group" v-if="(item['document_files'] && item['document_files'].length > 0)">
                <a class="btn-footer" :href="item['document_files'][0].file_url"> 
                  <font-awesome-icon icon="file-pdf" />
                </a>
                <router-link class="btn-footer" to="aktuelles">
                  <font-awesome-icon icon="arrow-right" />
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="btn-bar">
        <div class="btn-line"></div>
        <div class="btn">
          <div class="btn-inner">
            <router-link to="aktuelles">
              Mehr Anzeigen <br>
              <font-awesome-icon icon="chevron-down"/>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../event-bus.js'

export default {
  name: 'HomePosts',
  data () {
    return {
      posts: "12"
    }
  },
  mounted () {
    this.userID = this.$session.get("userID")
    this.axios.get('https://ff-pfaffenhofen.de/api/v1/announcements')
      .then( (res) => {
        this.posts = res["data"]["announcements"]
      })

    EventBus.$on('logout', () => {
      this.userID = ""
    })
    EventBus.$on('login', (userID) => {
      this.userID = userID
    })
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/theme.scss";

a {
  text-decoration: none;
}

.posts {
  background: $light-1;
}

h1 {
  color: $dark;
  font-size: 20px;
  text-align: center;

  svg {
    color: $primary-0;
    font-size: 38px;
    margin-right: 15px;
    transform: rotate(15deg);
  }

  @include mini {
    font-size: 30px;
  }
}

.text {
  text-align: center;
  color: $dark;
  opacity: 0.8;
}

.flex-row {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}

.card {
  width: 666px;
  box-shadow: $shadow-light;
  border: 1px solid lighten($gray-0, 15%);
  display: flex;
  margin-bottom: 20px;
  background: $light-0;
  border-radius: 4px;

  .content {
    padding: 10px 0px;
    flex: 1;

    span {
      font-size: larger !important;
    }
  }

  .category {
    font-weight: 600;
    color: $dark;
    font-size: 14px;
    color: $dark;
    margin: 4px 0px;
    padding: 0 20px;

    @include mini {
      font-size: 16px;
    }
  }

  .title {
    font-weight: 600;
    color: $dark;
    font-size: 16px;
    color: $primary-0;
    padding: 0 20px;

    @include mini {
      font-size: 20px;
    }
  }

  .body {
    color: $dark;
    opacity: 0.8;
    margin-top: 10px;
    padding: 0 20px;
    font-size: 13px;

    @include mini {
      font-size: 16px;
    }
  }

  .footer-item {
    font-weight: 600;
    color: $dark;
    font-size: 14px;
    margin-bottom: 5px;
    padding: 0 20px;
  }

  .footer {
    border-top: 2px solid lighten($gray-0, 15%);
    margin-top: 10px;
    padding-top: 15px;
    position: relative;
  }

  .btn-group {
    position: absolute;
    top: 28px;
    right: 25px;
  }

  .btn-footer {
    border: none;
    background: none;
    height: 40px;
    width: 40px;
    border-radius: 100%;
    opacity: 0.8;
    cursor: pointer;
    margin: 0px 5px;

    svg {
      font-size: 20px;
      color: $dark;
      margin: 0px 5px;
    }

    &:hover {
      opacity: 1;
    }
  }
}

.btn-bar {
  position: relative;
  padding-bottom: 100px;

  .btn-line {
    position: absolute;
    height: 2px;
    background: darken($light-0, 10%);
    width: 100%;
    top: 15px;
    z-index: 0;
  }

  .btn {
    position: absolute;
    top: 0;
    text-align: center;
    width: 100%;
  }

  .btn-inner {
    width: 270px;
    background: $light-1;
    z-index: 1;
    margin: 0 auto;
  }

  a {
    border: none;
    opacity: 0.6;
    font-weight: bold;
    text-transform: uppercase;
    font-size: 15px;
    cursor: pointer;
    color: $dark;
    text-decoration: none;

    &:hover {
      opacity: 0.8;
    }
  }
}

</style>
